// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DQ5N","name":"styles_name__xi4Je","phone":"styles_phone__XOsuC"};